import { render, staticRenderFns } from "./SdsItemViewer.vue?vue&type=template&id=e492fe40"
import script from "./SdsItemViewer.vue?vue&type=script&lang=js"
export * from "./SdsItemViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports